module.exports = __webpack_public_path__ + "media/images/payments/stripe-dark-00e381f9ec82e9bf2cbb2a7d07bd6ffa.svg";